import type { FC } from 'react';
import { useIntl } from 'react-intl';

import {
  formatEmployeesNumber,
  formatAmount,
} from '@xing-com/crate-entity-pages-common';
import { useModulesContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-modules-context';

import { EntityInfo } from './entity-info';

export const EntityInfoCompany: FC = () => {
  const { headerModule } = useModulesContext();
  const intl = useIntl();

  const headerContent = headerModule?.content;

  if (headerContent?.__typename !== 'EntityPageCompanyHeaderContent') {
    return null;
  }

  const entityInfoData = [];
  const companySizeRange = headerContent.company?.companySizeRange;
  const employeesCount = headerContent.company?.employeesCount;
  const followersTotal = headerContent.followers?.total || 0;

  if (followersTotal > 0) {
    entityInfoData.push({
      value: formatAmount({ value: followersTotal, intl }),
      label: ` ${intl.formatMessage({
        id: followersTotal > 1 ? 'EP_FOLLOWERS.other' : 'EP_FOLLOWERS.one',
      })}`,
      testId: 'HEADER_FOLLOWERS_TOTAL',
    });
  }

  if (companySizeRange && companySizeRange.min !== companySizeRange.max) {
    entityInfoData.push({
      value: formatEmployeesNumber(companySizeRange, intl),
      label: ` ${intl.formatMessage({ id: 'EP_EMPLOYEES' })}`,
      className: 'hideBorderOnLowRes',
      testId: 'HEADER_COMPANY_SIZE',
    });
  }

  if (
    companySizeRange &&
    companySizeRange.min !== companySizeRange.max &&
    employeesCount
  ) {
    entityInfoData.push({
      value: formatAmount({ value: employeesCount, intl }),
      label: ` ${intl.formatMessage({ id: 'EP_ON_XING' })}`,
      className: 'hideOnLowRes',
      testId: 'HEADER_EMPLOYEES_COUNT',
    });
  }

  return <EntityInfo data={entityInfoData} />;
};
